import { Fragment } from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from 'hooks';
import { IThirdPartyTypeGtwy } from 'types';
import {
  IApplicantConstant,
  IApplicantType,
  IThirdPartyConstantGtwy,
} from '../types';
import { ApplicantTypes, OtherTypes } from '../constants';
import { Button } from 'components/ui';
import { ButtonsWrapper, LoaderWrapper, Wrapper } from './type-changer.styled';
import { LinesLoader } from '../../loaders';

export const TypeChanger = observer(() => {
  const { createRequest, aiRequests } = useStore();

  const {
    applicantType,
    setApplicantType,
    thirdPartyType,
    setThirdPartyType,
    loading,
    getOtherProvidersByPhone,
    getOtherPersonAccounts,
  } = createRequest.applicant;

  const isLoading =
    createRequest.loading.areas.pending || loading.workers.pending;

  const handleChangeApplicantType = (value: IApplicantType): void => {
    if (value !== applicantType) {
      setApplicantType(value);

      if (value === 'other' && !loading.otherPersonAccounts.fulfilled) {
        getOtherPersonAccounts(createRequest.initialPhoneNumber);
      }
    }

    if (value !== 'tenant') {
      createRequest.setActiveHistoryTab('house');
    }
  };

  const handleChangeOtherType = (value: IThirdPartyTypeGtwy): void => {
    if (value !== thirdPartyType) {
      setThirdPartyType(value);

      if (value === 'other_person' && !loading.otherPersonAccounts.fulfilled) {
        getOtherPersonAccounts(createRequest.initialPhoneNumber);
      }

      if (
        value === 'other_employee' &&
        !loading.otherProviderAccounts.fulfilled
      ) {
        getOtherProvidersByPhone(createRequest.initialPhoneNumber);
      }
    }
  };

  return (
    <Wrapper>
      {isLoading ? (
        <LoaderWrapper>
          <LinesLoader size={'medium'} loaderType={applicantType} />
        </LoaderWrapper>
      ) : (
        <>
          <ButtonsWrapper>
            {ApplicantTypes.map(
              (applicant: IApplicantConstant, index: number) => (
                <Fragment key={index}>
                  <Button
                    key={index}
                    mode="neutral"
                    variant="ghost"
                    size="s"
                    selected={applicantType === applicant.value}
                    disabled={aiRequests.isAiMode}
                    onClick={() => handleChangeApplicantType(applicant.value)}
                  >
                    {applicant.text}
                  </Button>
                </Fragment>
              )
            )}
          </ButtonsWrapper>

          {applicantType === 'other' && (
            <ButtonsWrapper>
              {OtherTypes.map(
                (other: IThirdPartyConstantGtwy, index: number) => (
                  <Button
                    key={index}
                    mode="neutral"
                    variant="ghost"
                    size="s"
                    selected={thirdPartyType === other.value}
                    onClick={() => handleChangeOtherType(other.value)}
                  >
                    {other.text}
                  </Button>
                )
              )}
            </ButtonsWrapper>
          )}
        </>
      )}
    </Wrapper>
  );
});
